




import {Vue, Component} from 'vue-property-decorator'

import ContactSent from '@/components/ContactSent.vue'

@Component({
  components: {
      ContactSent
  }
})
export default class ContactSentView extends Vue {

}
